import React, { useState } from 'react';
import styles from './styles/ViewTableOfContents.module.css';
import { FaArrowLeft, FaChevronDown, FaChevronUp } from 'react-icons/fa';

const ViewTableOfContents = ({ tableOfContents, currentSituationId, setCurrentSituationId, toggleToC, handleFromToC, currentLogInfo, preview, visitedSituationPreview }) => {
    
    const [expandedSections, setExpandedSections] = useState(
        tableOfContents.contents.map(content =>
            content.sections ? content.sections.map(() => true) : []
        )
    );
    
    const handleSectionToggle = (contentIndex, sectionIndex) => {
        setExpandedSections(prevState => {
            const newState = prevState.map((contentSections, cIndex) =>
                cIndex === contentIndex
                    ? contentSections.map((isExpanded, sIndex) =>
                        sIndex === sectionIndex ? !isExpanded : isExpanded
                    )
                    : contentSections
            );
            return newState;
        });
    };

    const handleItemClick = (situationId, isAccessible) => {
        if (isAccessible) {
            setCurrentSituationId(situationId);
            handleFromToC(true);
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <FaArrowLeft className={styles.backButton} onClick={toggleToC} />
                <div className={styles.tocTitle}>Table of Contents</div>
            </div>
            <div className={styles.tocContents}>
                {tableOfContents.contents.map((content, contentIndex) => (
                    <div key={contentIndex} className={styles.tocContent}>
                        {content.sections && content.sections.filter(s => !s.disabled).map((section, sectionIndex) => {
                            const behavior = section.behavior || 'alwaysAccessible';

                            return (
                                <div key={sectionIndex} className={styles.tocSection}>
                                    <div 
                                        className={styles.tocSectionLabel} 
                                        onClick={() => handleSectionToggle(contentIndex, sectionIndex)}
                                    >
                                        {section.label || 'Untitled'}
                                        {expandedSections[contentIndex]?.[sectionIndex] ? (
                                            <FaChevronUp className={styles.chevronIcon} />
                                        ) : (
                                            <FaChevronDown className={styles.chevronIcon} />
                                        )}
                                    </div>
                                    {expandedSections[contentIndex]?.[sectionIndex] && (
                                        <div className={styles.tocItemsList}>
                                            {section.items &&
                                                section.items
                                                    .filter(item => {
                                                        if (behavior !== 'revealOnVisit') return true;

                                                        const visitedSituations = preview ? visitedSituationPreview : currentLogInfo?.decisions?.map(d => (d.situationId?._id ?? d.situationId)?.toString());
                                                        return visitedSituations?.includes(item.situation);
                                                    })
                                                    .map((item, itemIndex) => {
                                                        const visitedSituations = preview ? visitedSituationPreview : currentLogInfo?.decisions?.map(d => (d.situationId?._id ?? d.situationId)?.toString());
                                                        const hasVisited = visitedSituations?.includes(item.situation);
                                                        let isAccessible = true;

                                                        if (behavior === 'showAllVisitOnly' && !hasVisited) {
                                                            isAccessible = false;
                                                        }

                                                        return (
                                                            <div 
                                                                key={itemIndex} 
                                                                disabled={!isAccessible}
                                                                className={`${styles.tocItem} ${item.situation === currentSituationId ? styles.selectedItem : ''} ${!isAccessible ? styles.notAccessible : ''}`} 
                                                                onClick={() => handleItemClick(item.situation, isAccessible)}
                                                            >
                                                                {item.label || 'Untitled'}
                                                            </div>
                                                        );
                                            })}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ViewTableOfContents;